export default __webpack_public_path__ + "static/media/man-trophy-illustration.45aa283f.png";